module.exports = __webpack_public_path__ + "static/media/logo_complet._noel_Olassist.4d88f4c7.png";